module.exports = __webpack_public_path__ + "static/media/calendartime.bb12adfb.svg";